"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDateLike = isDateLike;

var _dateUtil = require("../utils/date-util");

function isDateLike(value) {
  var date;

  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'string' && value.length > 9) {
    date = new Date(value);
  }

  if (!date) return false;
  return (0, _dateUtil.isValidDate)(date);
}